/**
 * Normalize a string (first code point) or numeric code point to a one-code-point string for
 * Unicode property tests. String iteration already yields whole code points; a number is turned
 * into its character (including unpaired surrogates via `fromCodePoint`).
 */
export function toCodePointChar(value: string | number): string {
  if (typeof value === "number") {
    return String.fromCodePoint(value);
  }
  return value;
}
